import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { formatAllocationAmount } from '../utils/webPortal';

const WebPortalAllocationPreview = ({ allocation }) => {
  if (!allocation || !allocation.rows || allocation.rows.length === 0) {
    return null;
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, mt: 3 }}>
      <Typography variant="subtitle1" gutterBottom>
        Web Portal Allocation
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Tagged Web Portal charges total {formatAllocationAmount(allocation.total)}.
        This breakdown is the GL coding for those lines and is not added to the report total.
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Division</TableCell>
              <TableCell>Branch</TableCell>
              <TableCell>GL Code</TableCell>
              <TableCell align="right">Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allocation.rows.map((row) => (
              <TableRow key={`${row.division}-${row.branch}-${row.gl_code}`}>
                <TableCell>{row.division === 'sales' ? 'Sales' : 'Service'}</TableCell>
                <TableCell>{row.branch}</TableCell>
                <TableCell>{row.gl_code}</TableCell>
                <TableCell align="right">{formatAllocationAmount(row.amount)}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={3} align="right">
                <Typography variant="subtitle2">Allocation total</Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="subtitle2">
                  {formatAllocationAmount(allocation.allocatedTotal)}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3} align="right">Variance</TableCell>
              <TableCell align="right">{formatAllocationAmount(allocation.variance)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default WebPortalAllocationPreview;
